import { render, staticRenderFns } from "./AuthProfile.vue?vue&type=template&id=64ad4b4e&"
import script from "./AuthProfile.vue?vue&type=script&lang=js&"
export * from "./AuthProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports